(function () {
  function initRhdUspCarousels() {
    if (typeof Swiper === "undefined") return false;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    document.querySelectorAll(".js-rhd-usp-swiper").forEach((el) => {
      if (el.swiper) {
        el.swiper.update();
        return;
      }

      const slides = el.querySelectorAll(".swiper-slide");
      if (slides.length < 2) return;

      const prev = el.querySelector(".rhd-usp__arrow--prev");
      const next = el.querySelector(".rhd-usp__arrow--next");

      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        // loop + missing slides triggers getComputedStyle(null) in Swiper
        loop: false,
        rewind: slides.length > 1,
        speed: 450,
        // Keep theme aria-labels; avoid Swiper injecting invalid aria-controls
        a11y: false,
        autoplay: reduceMotion
          ? false
          : {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
        navigation:
          prev && next
            ? {
                prevEl: prev,
                nextEl: next,
              }
            : undefined,
        breakpoints: {
          750: {
            enabled: false,
          },
        },
      });

      // Navigation module may still set aria-controls to a missing id
      if (prev) prev.removeAttribute("aria-controls");
      if (next) next.removeAttribute("aria-controls");
    });

    return true;
  }

  function boot() {
    if (!initRhdUspCarousels()) {
      window.addEventListener("load", initRhdUspCarousels, { once: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", initRhdUspCarousels);
})();
